module.exports = __webpack_public_path__ + "img/icon-activity-note.4168bbf0.svg";